<template>
  <div class="single_slider  wow fadeInDown" data-wow-delay="0.7s" >
    <agile :initial-slide="0" :options="options_main_slider">
      <div v-for="(item, i) in items" :key="i" :src="item.src" class="slide">
        <img :src="item.src" class="slide wow fadeInRight" data-wow-delay="0.9s" />
        <div class="single_slider__descr wow fadeInDown" data-wow-delay="0.9s">
          <div class="single_slider__title">{{ item.title }}</div>
          <div class="single_slider__sm_title">{{ item.sm_title }}</div>
          <div class="single_slider__sm_descr" v-html="item.descr">{{ item.descr }}</div>

          <!--          <img class="single_slider__inside" :src="item.svg" v-if="item.svg" />-->
        </div>
      </div>
      <template slot="prevButton" >
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5 4.5L7 9L11.5 13.5"
            stroke="white"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <template slot="nextButton">
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 13.5L12 9L7.5 4.5"
            stroke="white"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </agile>
  </div>
</template>

<script>
export default {
  props: {
    items: Array | String | Number | Boolean | Object,
  },
  name: "carousel",
  data() {
    return {
      options_main_slider: {
        fade: true,
        navButtons: true,
        dots: true,
        infinite: true,
        autoplay: true,
        // pauseOnDotsHover: true,
        pauseOnHover: false,
        // navButtons: true,
        autoplaySpeed: "5000",
        speed: "1000",
        // responsive: [
        //   {
        //     breakpoint: 600,
        //     settings: {
        //       navButtons: false,
        //       dots: false,
        //       infinite: true,
        //     },
        //   },
        //   {
        //     breakpoint: 1280,
        //     settings: {
        //       navButtons: true,
        //       dots: true,
        //       infinite: true,
        //     },
        //   },
        // ],
      },

      // items: [
      //   {
      //     src: "/local/templates/international/img/209747913.jpg",
      //     // img: "img/novaroll_text_banner.svg",
      //     title: "Цифровая трансформация",
      //     sm_title: "будущее, доступное сегодня",
      //     descr: "Интегрируем передовые технологии <br> в производстве, логистике и продажах",
      //     link: "",
      //   },
      //   {
      //     src: "/local/templates/international/img/209747912 (2).jpg",
      //     // img: "img/novaroll_text_banner.svg",
      //     title: "C заботой об экологии",
      //     sm_title: "в современном бизнесе",
      //     descr: "Разрабатываем новые подоходы \n" +
      //     "к производству продукции",
      //     link: "",
      //   },
      //   {
      //     src: "/local/templates/international/img/209747912-1.jpg",
      //     // img: "img/novaroll_text_banner.svg",
      //     title: "Цифровая трансформация",
      //     sm_title: "будущее, доступное сегодня",
      //     descr: "Интегрируем передовые технологии <br> в производстве, логистике и продажах",
      //     link: "",
      //   },
      // ],
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "../../theme/_variable.scss";
</style>

<style lang="scss">
.single_slider {
  margin-top: 120px;

  & .agile__actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    margin-right: 0;
    -webkit-box-pack: normal;
    -ms-flex-pack: normal;
    justify-content: normal;
    left: 92px;
    bottom: 130px;
  }

  & .agile__actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    margin-right: 0;
    -webkit-box-pack: normal;
    -ms-flex-pack: normal;
    justify-content: normal;
  }

  & .agile__dots {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    & .agile__dot {
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  & .agile__nav-button {
    border: none;
    color: #fff;
    font-size: 24px;
    position: relative;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    width: 30px;
    height: 30px;
    background: #282828;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  & .agile__slides {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  & .single_slider__descr {
    position: absolute;
    z-index: 1;
    color: white;
    font-size: 71px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-top: 120px;
    margin-left: 80px;
    max-width: 600px;

    & .single_slider__title {
      font-family: "MuseoSansCyrl-700";
      font-style: normal;
      font-weight: 600;
      font-size: 40px;
      line-height: 120%;
      color: #282828;
      margin-bottom: 20px;
    }
    & .single_slider__sm_title {
      font-family: "MuseoSansCyrl-500";
      font-style: normal;
      font-weight: normal;
      font-size: 25px;
      line-height: 120%;
      color: #888888;
    }
    & .single_slider__sm_descr {
      font-family: "RobotoRegular";
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 140%;
      color: #282828;
      margin-top: 80px;
      max-width: 400px;
    }

    & .single_slider__inside {
      width: auto;
      margin-left: 148px;
      margin-bottom: 63px;
    }
  }

  & .agile__list {
    background: #ffffff;
    -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
    border-radius: 20px;
  }

  .agile__nav-button:hover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }

  .agile__nav-button--prev {
    left: 0;
  }

  .agile__nav-button--next {
    right: 0;
  }

  .agile__dot {
    margin-left: 12px;
  }

  .agile__dot button {
    background-color: transparent;
    border: 1px solid #dedede;
    background: #dedede;
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    width: 10px;
  }

  .agile__dot--current button,
  .agile__dot:hover button {
    background-color: #ff4237;
    border: 1px solid #ff4237;
  }

  & .slide {
    display: block;
    height: 819px;
    margin-left: auto;
  }
  & img.slide {
  }
}
</style>
